import { queryPathBuilder } from '../../util/queryPathBuilder';
import { GET_ALL_SYSTEM_LOGS } from '../types';

import { get } from './Action';

const basePath = '/system-log';

// Get All Roles
export const getAllSystemLogs = (params) => async (dispatch) => {
  const queryParams = queryPathBuilder(params);
  return await dispatch(get(`${basePath}${queryParams}`, getSystemLogsDS, true));
};

const getSystemLogsDS = (logs) => ({
  type: GET_ALL_SYSTEM_LOGS,
  payload: logs?.items,
});
